import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function DefaultRedirect() {
  const { user, loading, isAdmin, isManager, isSuperAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="spinner mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Super admin (admin@mastersunion.org) always goes to admin dashboard - no panel selection
  // Use window.location to force immediate redirect
  if (isSuperAdmin() && user.email === 'admin@mastersunion.org') {
    window.location.href = '/';
    return null;
  }

  // Other admins go to admin dashboard
  if (isAdmin()) {
    return <Navigate to="/" replace />;
  }

  // Manager-admin goes to admin dashboard
  if (user.role === 'manager-admin') {
    return <Navigate to="/" replace />;
  }

  // Managers go to manager dashboard
  if (isManager()) {
    return <Navigate to="/manager-dashboard" replace />;
  }

  // Regular users go to user dashboard (but not super admin)
  if (user.role === 'user' && !(isSuperAdmin() && user.email === 'admin@mastersunion.org')) {
    return <Navigate to="/user-dashboard" replace />;
  }
  
  // If somehow super admin gets here with user role, redirect to admin dashboard
  if (isSuperAdmin() && user.email === 'admin@mastersunion.org') {
    window.location.href = '/';
    return null;
  }

  return <Navigate to="/login" replace />;
}

export default DefaultRedirect;
